import "./NewsletterPage.css";
import ContactFormWithBackground from "../../../components/ContactFormWithBackgroundGray/ContactFormWithBackground";

export default function NewsletterPage() {
    return (
        <>
            <ContactFormWithBackground />
        </>
    );
}
